import { usePublicMode } from "@Src/contexts/PublicModeContext";
import { AppBarToolbar } from "@Src/layout/AppBarToolbar";
import { Box, type Theme, useMediaQuery } from "@mui/material";
import { AppBar, TitlePortal } from "react-admin";

const Logo = () => {
	return null;
};

const CustomAppBar = () => {
	const { isPublic } = usePublicMode();

	const isLargeEnough = useMediaQuery<Theme>((theme) =>
		theme.breakpoints.up("sm"),
	);

	if (isPublic === true) return null;

	return (
		<AppBar color="secondary" toolbar={<AppBarToolbar />}>
			<TitlePortal />
			{isLargeEnough && <Logo />}
			{isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
		</AppBar>
	);
};

export default CustomAppBar;
